// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-container[data-v-a2445d98]{background-image:linear-gradient(to right,var(--shared-auth-app-header-bar-background-color-from,var(--surface-100)),var(--shared-auth-app-header-bar-background-color-to,var(--surface-100)))}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
